import { IDatasetLensColumn, IReportCoaDimensionMetadata, IReportDimension } from '@opengov/reporting-types';

import { ISelectOption } from '../../../src/components/common/SelectWithChildren/SelectWithChildren';

export interface IShowCoaAccountTypePayload {
  coaAccountType: string;
  coaDimensionMetadata: IReportCoaDimensionMetadata;
  selectedShow: ISelectOption['value'];
  selectedRow: [string, string];
  selectedColumn: [string, string];
  queryIndex: number;
}

export interface IRowsColumnPayload {
  coaDimensionMetadata: IReportCoaDimensionMetadata;
  selectedRow: [string, string];
  queryIndex: number;
}

export interface IColumnsColumnPayload {
  coaDimensionMetadata: IReportCoaDimensionMetadata;
  dateDimension: IReportDimension;
  lensDateColumns: IDatasetLensColumn[];
  lensYearColumns: IDatasetLensColumn[];
  selectedColumn: [string, string];
}

export enum ControlBlockStatus {
  Current = 'current',
  Updating = 'updating',
  Loading = 'loading'
}

export interface IShowCoaAccountWithColumnsColumn extends IShowCoaAccountTypePayload, IColumnsColumnPayload {}
